import React from 'react';
import { Badge } from '../ui/Badge';
import { Card } from '../ui/Card';
import { Building, TrendingUp, FileCheck, ArrowUpRight } from 'lucide-react';
export function ProductShowcase() {
  return <section className="py-24 bg-slate-900 text-white overflow-hidden" data-id="element-168">
      <div className="container mx-auto px-4 md:px-6" data-id="element-169">
        <div className="text-center mb-16" data-id="element-170">
          <Badge variant="default" className="bg-blue-500/10 text-blue-400 border-blue-500/20 mb-4" data-id="element-171">
            Platforma Digitală
          </Badge>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-172">
            Totul într-un singur dashboard
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-173">
            Urmărește statusul aplicațiilor, gestionează documentele și compară
            ofertele într-o interfață modernă și intuitivă.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-174">
          {/* Glow effect */}
          <div className="absolute -inset-1 bg-gradient-to-r from-blue-500 to-indigo-500 rounded-2xl blur opacity-20" data-id="element-175" />

          {/* Main Dashboard Mockup */}
          <div className="relative bg-slate-950 border border-slate-800 rounded-xl shadow-2xl overflow-hidden" data-id="element-176">
            {/* Fake Browser Header */}
            <div className="h-12 bg-slate-900 border-b border-slate-800 flex items-center px-4 gap-2" data-id="element-177">
              <div className="flex gap-1.5" data-id="element-178">
                <div className="w-3 h-3 rounded-full bg-red-500/20" data-id="element-179" />
                <div className="w-3 h-3 rounded-full bg-yellow-500/20" data-id="element-180" />
                <div className="w-3 h-3 rounded-full bg-green-500/20" data-id="element-181" />
              </div>
              <div className="ml-4 px-3 py-1 bg-slate-800 rounded-md text-xs text-slate-400 flex-1 max-w-xs" data-id="element-182">
                app.creditarea.com/dashboard
              </div>
            </div>

            {/* Dashboard Content */}
            <div className="p-6 md:p-8" data-id="element-183">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4" data-id="element-184">
                <div data-id="element-185">
                  <h3 className="text-2xl font-bold" data-id="element-186">
                    Bună ziua, Tech Solutions SRL
                  </h3>
                  <p className="text-slate-400" data-id="element-187">
                    CUI: RO12345678 • Ultima actualizare: Azi, 09:41
                  </p>
                </div>
                <button className="bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors" data-id="element-188">
                  Aplicație Nouă
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-189">
                <div className="bg-slate-900 p-4 rounded-lg border border-slate-800" data-id="element-190">
                  <div className="flex items-center gap-3 mb-2" data-id="element-191">
                    <div className="p-2 bg-blue-500/10 rounded-lg" data-id="element-192">
                      <TrendingUp className="h-5 w-5 text-blue-400" data-id="element-193" />
                    </div>
                    <span className="text-slate-400 text-sm" data-id="element-194">Scor Credit</span>
                  </div>
                  <div className="text-2xl font-bold" data-id="element-195">85/100</div>
                  <div className="text-emerald-400 text-xs mt-1" data-id="element-196">
                    Eligibilitate ridicată
                  </div>
                </div>
                <div className="bg-slate-900 p-4 rounded-lg border border-slate-800" data-id="element-197">
                  <div className="flex items-center gap-3 mb-2" data-id="element-198">
                    <div className="p-2 bg-purple-500/10 rounded-lg" data-id="element-199">
                      <Building className="h-5 w-5 text-purple-400" data-id="element-200" />
                    </div>
                    <span className="text-slate-400 text-sm" data-id="element-201">
                      Bănci Compatibile
                    </span>
                  </div>
                  <div className="text-2xl font-bold" data-id="element-202">7 Bănci</div>
                  <div className="text-slate-500 text-xs mt-1" data-id="element-203">
                    Din 12 parteneri
                  </div>
                </div>
                <div className="bg-slate-900 p-4 rounded-lg border border-slate-800" data-id="element-204">
                  <div className="flex items-center gap-3 mb-2" data-id="element-205">
                    <div className="p-2 bg-emerald-500/10 rounded-lg" data-id="element-206">
                      <FileCheck className="h-5 w-5 text-emerald-400" data-id="element-207" />
                    </div>
                    <span className="text-slate-400 text-sm" data-id="element-208">
                      Dosar Complet
                    </span>
                  </div>
                  <div className="text-2xl font-bold" data-id="element-209">100%</div>
                  <div className="text-emerald-400 text-xs mt-1" data-id="element-210">
                    Gata de trimitere
                  </div>
                </div>
              </div>

              <div className="bg-slate-900 rounded-lg border border-slate-800 overflow-hidden" data-id="element-211">
                <div className="px-6 py-4 border-b border-slate-800 flex justify-between items-center" data-id="element-212">
                  <h4 className="font-semibold" data-id="element-213">Oferte Recomandate</h4>
                  <span className="text-xs text-slate-400" data-id="element-214">
                    Actualizat în timp real
                  </span>
                </div>
                <div className="divide-y divide-slate-800" data-id="element-215">
                  {[1, 2, 3].map(i => <div key={i} className="p-4 flex items-center justify-between hover:bg-slate-800/50 transition-colors cursor-pointer group" data-id="element-216">
                      <div className="flex items-center gap-4" data-id="element-217">
                        <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center" data-id="element-218">
                          <span className="text-slate-900 font-bold text-xs" data-id="element-219">
                            BK{i}
                          </span>
                        </div>
                        <div data-id="element-220">
                          <div className="font-medium" data-id="element-221">
                            Credit Investiții - Banca {i}
                          </div>
                          <div className="text-xs text-slate-400" data-id="element-222">
                            Dobândă variabilă • 60 Luni
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-4" data-id="element-223">
                        <div className="text-right hidden sm:block" data-id="element-224">
                          <div className="font-bold text-emerald-400" data-id="element-225">
                            Pre-aprobat
                          </div>
                          <div className="text-xs text-slate-500" data-id="element-226">
                            până la 500.000 RON
                          </div>
                        </div>
                        <ArrowUpRight className="h-5 w-5 text-slate-600 group-hover:text-white transition-colors" data-id="element-227" />
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}